import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';
import { linkAccount } from 'services/auth';
import { IExternalLinkPayload } from 'services/auth/types';

export const ThunkLinkExternalAccount = createAsyncThunk<boolean, IExternalLinkPayload>(
  `${storeResources.AUTH}/linkAccount`,
  payload => linkAccount(payload).then(r => r.data),
);
